export default [  
  {
    path: '/suppliers',
    name: 'suppliers',
    component: () => import('@/views/modules/suppliers/list'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Suppliers List',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Suppliers' }
      ]
    },
    children:[
      {
        path: '/suppliers/create',
        name: 'suppliers-create',
        component: () => import('@/views/modules/suppliers/create'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Supplier Create',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Suppliers', link: '/suppliers' },
            { text: 'Create' }
          ]
        }
      },
      {
        path: '/suppliers/:id/edit',
        props: true,
        name: 'suppliers-edit',
        component: () => import('@/views/modules/suppliers/edit'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Suppliers Edit',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Supplier',  to: { name: "suppliers-show" }, param: 'id' },
            { text: 'Edit' }
          ]
        }
      },
      {
        path: '/suppliers/:id/show',
        props: true,
        name: 'suppliers-show',
        component: () => import('@/views/modules/suppliers/show'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Suppliers Details',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Suppliers',  to: { name: "suppliers" } },
            { text: 'Details' }
          ]
        }
      },
    
    ]
  },
 
]